(function () {
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    const popup = document.querySelector('.swatch-popup');
    const triggers = document.querySelectorAll('.swatch_popup_trigger');
    if (!popup || !triggers.length) return;

    const overlayEls = popup.querySelectorAll('[data-swatch-popup-close]');
    const grid = popup.querySelector('[data-swatch-grid]');
    const errorBox = popup.querySelector('.swatch-popup__errors');
    const tabButtons = popup.querySelectorAll('[data-swatch-filter]');
    const moreBtn = popup.querySelector('[data-swatch-more]');
    const MAX_VISIBLE = 12;

    let cartVariantIds = new Set();
    let isSyncingCart = false;

    // ---------- helpers ----------
    function showError(message) {
        if (!errorBox) return;
        errorBox.textContent = message || '';
        errorBox.classList.toggle('is-visible', !!message);
    }

    function normalize(str) {
        return String(str || '').trim().toLowerCase();
    }

    function getTiles() {
        return Array.from(grid.querySelectorAll('.swatch-tile'));
    }

    function normalizeKey(str) {
        return String(str || '')
            .toLowerCase()
            .trim()
            .replace(/&/g, 'and')
            .replace(/\s+/g, ' ')
            .replace(/[^a-z0-9]+/g, ' ')   // прибирає тире/двокрапки/спецсимволи
            .trim();
    }
    function hideCustomDuplicatesOfStandard() {
        const tiles = getTiles();

        // 1) збираємо ключі зі STANDARD (Wood)
        const standardKeys = new Set();
        tiles.forEach((tile) => {
            const group = tile.getAttribute('data-swatch-group');
            const subgroup = tile.getAttribute('data-swatch-subgroup');
            if (group !== 'Wood' || subgroup !== 'standard') return;

            const title = tile.getAttribute('data-variant-title');
            const key = normalizeKey(title);
            if (key) standardKeys.add(key);
        });

        // 2) ховаємо CUSTOM якщо key вже є в STANDARD
        tiles.forEach((tile) => {
            const group = tile.getAttribute('data-swatch-group');
            const subgroup = tile.getAttribute('data-swatch-subgroup');
            if (group !== 'Wood' || subgroup !== 'custom') return;

            const title = tile.getAttribute('data-variant-title');
            const key = normalizeKey(title);
            const isDup = key && standardKeys.has(key);

            tile.classList.toggle('is-duplicate-standard', !!isDup);
        });
    }

    /**
     * ✅ IMPORTANT FIX:
     * We take allowed values from DOM option inputs (Colour/Color) that are NOT disabled.
     * This matches exactly what the customer can pick right now (e.g., after size selection).
     * Fallback: use the JSON script tag data-current-wood-values if present.
     */
    function getAllowedWoodTitlesFromPdp() {
        const node = document.querySelector('[data-current-wood-values]');
        if (!node) return null;

        try {
            const arr = JSON.parse(node.textContent || '[]');
            if (!Array.isArray(arr)) return null;
            return Array.from(new Set(arr.map(normalize).filter(Boolean)));
        } catch (e) {
            return null;
        }
    }

    function filterStandardWoodByCurrentProduct() {
        const allowed = getAllowedWoodTitlesFromPdp();
        if (allowed == null) return;

        const tiles = getTiles();

        tiles.forEach((tile) => {
            const group = tile.getAttribute('data-swatch-group');
            const subgroup = tile.getAttribute('data-swatch-subgroup'); // 'standard' / 'custom'
            if (group !== 'Wood' || subgroup !== 'standard') return;

            const title = normalize(tile.getAttribute('data-variant-title'));
            const isAllowed = allowed.length ? allowed.includes(title) : false;

            tile.classList.toggle('is-not-in-product', !isAllowed);
        });

        // hide STANDARD heading if none visible
        const heading = popup.querySelector('[data-swatch-title="Wood-Standard"]');
        if (heading) {
            const anyVisible = tiles.some((t) => {
                return (
                    t.getAttribute('data-swatch-group') === 'Wood' &&
                    t.getAttribute('data-swatch-subgroup') === 'standard' &&
                    !t.classList.contains('is-not-in-product')
                );
            });
            heading.style.display = anyVisible ? '' : 'none';
        }
    }

    function setTileInCart(tile, inCart) {
        if (!tile) return;
        tile.dataset.inCart = inCart ? 'true' : 'false';
        tile.classList.toggle('is-in-cart', !!inCart);

        const btn = tile.querySelector('[data-swatch-action="toggle"]');
        if (!btn) return;

        if (inCart) {
            btn.innerHTML = `
        <svg fill="black" width="24px" height="24px" viewBox="-0.18 -0.18 0.72 0.72" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin" class="jam jam-close"><path d="m0.22 0.177 0.107 -0.107A0.029 0.029 0 1 0 0.283 0.028l-0.105 0.107 -0.107 -0.107a0.029 0.029 0 1 0 -0.043 0.043l0.107 0.107 -0.107 0.105a0.029 0.029 0 1 0 0.043 0.043l0.107 -0.107 0.107 0.107A0.029 0.029 0 1 0 0.327 0.283z"/></svg>
      `;
        } else {
            btn.innerHTML = `
        <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <rect x="0" y="0" width="24" height="24"></rect>
            <path d="M15.3214286,9.5 C15.3214286,7.93720195 15.3214286,6.5443448 15.3214286,5.32142857 C15.3214286,3.48705422 13.8343743,2 12,2 C10.1656257,2 8.67857143,3.48705422 8.67857143,5.32142857 C8.67857143,6.5443448 8.67857143,7.93720195 8.67857143,9.5" stroke="black" stroke-width="1.5"></path>
            <polygon stroke="black" stroke-width="1.5" points="5.35714286 7.70535714 18.6428571 7.70535714 19.75 21.2678571 4.25 21.2678571"></polygon>
          </g>
        </svg>
      `;
        }
    }

    function limitVisibleTiles() {
        if (!moreBtn) return;

        const tiles = getTiles().filter((t) => {
            if (t.classList.contains('is-not-in-product')) return false;
            if (t.classList.contains('is-filter-hidden')) return false;
            return true;
        });

        if (tiles.length <= MAX_VISIBLE) {
            moreBtn.style.display = 'none';
            return;
        }

        tiles.forEach((tile, idx) => {
            if (idx >= MAX_VISIBLE) tile.classList.add('is-extra', 'is-hidden');
            else tile.classList.remove('is-extra', 'is-hidden');
        });

        moreBtn.style.display = '';

        moreBtn.addEventListener(
            'click',
            () => {
                tiles.forEach((t) => t.classList.remove('is-hidden'));
                moreBtn.style.display = 'none';
            },
            { once: true }
        );
    }

    function notifyCartChanged(openDrawer) {
        const detail = openDrawer ? { openDrawer: true } : {};
        document.documentElement.dispatchEvent(
            new CustomEvent('theme:cartchanged', {
                bubbles: true,
                cancelable: false,
                detail: detail
            })
        );
    }

    function fetchCart() {
        return fetch(root + 'cart.js', {
            headers: { Accept: 'application/json' }
        }).then((res) => res.json());
    }

    function syncCartState() {
        if (isSyncingCart) return;
        isSyncingCart = true;

        fetchCart()
            .then((cart) => {
                cartVariantIds = new Set(cart.items.map((i) => String(i.variant_id)));
                getTiles().forEach((tile) => {
                    const id = tile.getAttribute('data-variant-id');
                    setTileInCart(tile, cartVariantIds.has(String(id)));
                });
            })
            .catch(() => {})
            .finally(() => {
                isSyncingCart = false;
            });
    }

    function addVariantToCart(variantId) {
        return fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        }).then(async (res) => {
            if (!res.ok) {
                const data = await res.json().catch(() => null);
                const msg = data && data.description ? data.description : 'Cannot add item.';
                throw new Error(msg);
            }
            return res.json();
        });
    }

    function removeVariantFromCart(variantId) {
        return fetch(root + 'cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify({ id: String(variantId), quantity: 0 })
        }).then(async (res) => {
            if (!res.ok) {
                const data = await res.json().catch(() => null);
                const msg = data && data.description ? data.description : 'Cannot remove item.';
                throw new Error(msg);
            }
            return res.json();
        });
    }

    function filterByGroup(group) {
        const tiles = getTiles();

        tiles.forEach((tile) => {
            const tileGroup = tile.getAttribute('data-swatch-group');
            const isDup = tile.classList.contains('is-duplicate-standard');

            const matches = !isDup && (!group || group === 'all' || tileGroup === group);
            tile.classList.toggle('is-filter-hidden', !matches);
        });

        limitVisibleTiles();
    }

    function openPopup() {
        popup.classList.add('is-open');
        popup.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('swatch-popup-open');

        // ✅ apply STANDARD filter based on current PDP selectable options
        filterStandardWoodByCurrentProduct();
        hideCustomDuplicatesOfStandard();

        // keep current active tab behavior
        const defaultTab = popup.querySelector('[data-swatch-filter].is-active');
        if (defaultTab) filterByGroup(defaultTab.getAttribute('data-swatch-filter'));
        else filterByGroup('all');

        syncCartState();
    }

    function closePopup() {
        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('swatch-popup-open');
        showError('');
    }

    // ---------- events ----------
    triggers.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            openPopup();
        });
    });

    overlayEls.forEach((el) => {
        el.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && popup.classList.contains('is-open')) {
            closePopup();
        }
    });

    tabButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
            const group = btn.getAttribute('data-swatch-filter');
            tabButtons.forEach((b) => b.classList.toggle('is-active', b === btn));
            filterByGroup(group);
        });
    });

    grid.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-swatch-action="toggle"]');
        if (!btn) return;

        const tile = btn.closest('.swatch-tile');
        const variantId = tile && tile.getAttribute('data-variant-id');
        if (!variantId) return;

        if (tile.classList.contains('is-not-in-product')) return;

        const inCart = tile.dataset.inCart === 'true';
        showError('');
        btn.disabled = true;
        btn.classList.add('is-loading');

        const promise = inCart ? removeVariantFromCart(variantId) : addVariantToCart(variantId);

        promise
            .then(() => {
                setTileInCart(tile, !inCart);
                notifyCartChanged(!inCart);
            })
            .catch((err) => {
                showError(err.message);
            })
            .finally(() => {
                btn.disabled = false;
                btn.classList.remove('is-loading');
            });
    });

    // initial
    limitVisibleTiles();
})();
